import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { listOutline, mapOutline } from 'ionicons/icons';

export type ViewMode = 'list' | 'map';

@Component({
  selector: 'x-view-toggle',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './x-view-toggle.component.html',
  styleUrl: './x-view-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XViewToggleComponent {
  activeView = input<ViewMode>('list');
  viewChange = output<ViewMode>();

  constructor() {
    addIcons({ listOutline, mapOutline });
  }
}
